/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Unified Android Exam APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  SaveStudentSubmisionFileRequest,
  SubmissionUploadUrlResponse,
} from ".././model";

import { customInstance } from "../../../api-client";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get presigned URL for submission upload
 */
export const getSubmissionUploadUrl = (
  examId: string,
  studentId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<SubmissionUploadUrlResponse>(
    {
      url: `/exams/${examId}/students/${studentId}/submissionUploadUrl`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getGetSubmissionUploadUrlQueryKey = (
  examId?: string,
  studentId?: string,
) => {
  return [
    `/exams/${examId}/students/${studentId}/submissionUploadUrl`,
  ] as const;
};

export const getGetSubmissionUploadUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetSubmissionUploadUrlQueryKey(examId, studentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSubmissionUploadUrl>>
  > = ({ signal }) =>
    getSubmissionUploadUrl(examId, studentId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(examId && studentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSubmissionUploadUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSubmissionUploadUrl>>
>;
export type GetSubmissionUploadUrlQueryError = unknown;

export function useGetSubmissionUploadUrl<
  TData = Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
          TError,
          Awaited<ReturnType<typeof getSubmissionUploadUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubmissionUploadUrl<
  TData = Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
          TError,
          Awaited<ReturnType<typeof getSubmissionUploadUrl>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSubmissionUploadUrl<
  TData = Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get presigned URL for submission upload
 */

export function useGetSubmissionUploadUrl<
  TData = Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
  TError = unknown,
>(
  examId: string,
  studentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getSubmissionUploadUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSubmissionUploadUrlQueryOptions(
    examId,
    studentId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Notify server after student submission file upload (typo preserved from client path)
 */
export const saveStudentSubmissionFile = (
  saveStudentSubmisionFileRequest: SaveStudentSubmisionFileRequest,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<boolean>(
    {
      url: `/exams/saveStudentSubmisionFile`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: saveStudentSubmisionFileRequest,
      signal,
    },
    options,
  );
};

export const getSaveStudentSubmissionFileMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveStudentSubmissionFile>>,
    TError,
    { data: SaveStudentSubmisionFileRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveStudentSubmissionFile>>,
  TError,
  { data: SaveStudentSubmisionFileRequest },
  TContext
> => {
  const mutationKey = ["saveStudentSubmissionFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveStudentSubmissionFile>>,
    { data: SaveStudentSubmisionFileRequest }
  > = (props) => {
    const { data } = props ?? {};

    return saveStudentSubmissionFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveStudentSubmissionFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveStudentSubmissionFile>>
>;
export type SaveStudentSubmissionFileMutationBody =
  SaveStudentSubmisionFileRequest;
export type SaveStudentSubmissionFileMutationError = unknown;

/**
 * @summary Notify server after student submission file upload (typo preserved from client path)
 */
export const useSaveStudentSubmissionFile = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof saveStudentSubmissionFile>>,
      TError,
      { data: SaveStudentSubmisionFileRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof saveStudentSubmissionFile>>,
  TError,
  { data: SaveStudentSubmisionFileRequest },
  TContext
> => {
  const mutationOptions = getSaveStudentSubmissionFileMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
